import { useCallback, useMemo, useState } from 'react';
export const usePreventLeave = ({ onLeaveConfirmation, dirtyFields }) => {
    const [showPreventLeave, setShowPreventLeave] = useState(false);
    const handleLeave = useCallback(() => {
        const isDirty = Object.keys(dirtyFields).length > 0;
        if (isDirty) {
            setShowPreventLeave(true);
        }
        else {
            setShowPreventLeave(false);
            onLeaveConfirmation();
        }
    }, [onLeaveConfirmation, dirtyFields]);
    const preventLeaveModalProps = useMemo(() => ({
        opened: showPreventLeave,
        onCancel: () => setShowPreventLeave(false),
        onConfirm: () => {
            setShowPreventLeave(false);
            onLeaveConfirmation();
        }
    }), [showPreventLeave, onLeaveConfirmation]);
    return {
        preventLeaveModalProps,
        showPreventLeave,
        handleLeave
    };
};
